module.exports = __webpack_public_path__ + "teqbahn-assets/media/8.45c76299.jpg";